<script>
export default {
  props: {
    type: String,
    url: String,
    scrollToId: String,
    showIds: String,
    hideIds: String,
    pageId: String,
    youtubeId: String,
    vimeoId: String,
    popupId: String,
    email: String,
    emailSubject: String,
    targetBlank: {
      default: false,
      type: Boolean,
    },
    renderLink: {
      default: false,
      type: Boolean,
    },
  },
  render: function (h) {
    if (this.renderLink) {
      return h(
        'a',
        {
          attrs: {
            ...this.$attrs,
            ...this.actionAttrs,
          },
          on: {},
        },
        [
          this.$scopedSlots.default({
            actionAttrs: this.actionAttrs,
            handleClick: this.handleClick,
          }),
        ],
      );
    } else {
      return this.$scopedSlots.default({
        actionAttrs: this.actionAttrs,
        handleClick: this.handleClick,
      });
    }
  },
  watch: {},
  data: function () {
    return {
      pageSlug: Object.freeze(
        this.$getLocalized(`pageIdToSlug${this.pageId}`, null),
      ),
    };
  },
  serverPrefetch() {
    /* Localize pageId to slug */
    if (this.pageId && this.type === 'page') {
      const page = this.$ssrContext.funnel.pages.find(
        (p) => p.id === this.pageId,
      );
      const slug = page ? page.settings.slug : null;
      this.pageSlug = this.$setLocalized(
        `pageIdToSlug${this.pageId}`,
        slug,
        this.$ssrContext,
      );
    }
  },
  methods: {
    handleClick() {},
  },
  computed: {
    /* Returns object that can be spread on underlying node 
    to apply the appropriate tags. E.g. hrefs, targets for outgoing links */
    actionAttrs() {
      const attrs = {href: '#'};

      if (this.type === 'page' && this.pageSlug) {
        attrs.href = `./${this.pageSlug}`;
      }

      if (this.type === 'external') {
        attrs.href = this.url;
      }

      if (this.type === 'scroll') {
        attrs.href = this.scrollToId;
      }

      if (this.type === 'showHide') {
        attrs['data-click'] = JSON.stringify({
          event: this.type, // show
          payload: {
            showIds: this.showIds,
            hideIds: this.hideIds,
          },
        });
      }

      if ((this.type === 'page' && this.pageSlug) || this.type === 'external') {
        attrs.target = this.targetBlank ? '_blank' : '_self';
      }

      if (this.type === 'youtubeLightbox') {
        const youtubeId = this.youtubeId || 'tk36ovCMsU8';
        attrs['data-click'] = JSON.stringify({
          event: 'openVideoLightbox',
          payload: {
            type: 'youtube',
            id: youtubeId,
          },
        });
        attrs.href = `https://www.youtube.com/watch?v=${youtubeId}`;
      }

      if (this.type === 'email') {
        const email = this.email || 'noreply@converdy.com';
        attrs.target = '_blank';
        attrs.href = `mailto:${email}`;
        if (this.emailSubject) {
          attrs.href += `?subject=${this.emailSubject}`;
        }
      }

      if (this.type === 'vimeoLightbox') {
        let vimeoId = this.vimeoId || '76979871';
        attrs['data-click'] = JSON.stringify({
          event: 'openVideoLightbox',
          payload: {
            type: 'vimeo',
            id: vimeoId,
          },
        });

        attrs.href = `https://vimeo.com/${vimeoId}`;
      }

      if (this.type === 'popup') {
        attrs['data-click'] = JSON.stringify({
          event: 'openPopup',
          payload: this.popupId,
        });
      }

      if (this.type === 'openPrintWishlist') {
        attrs['data-click'] = JSON.stringify({
          event: 'openPrintWishlist',
        });
      }

      if (this.type === 'closePopups') {
        attrs['data-click'] = JSON.stringify({
          event: 'closePopups',
        });
      }

      return attrs;
    },
  },
};
</script>

<style>
[data-click] {
  cursor: pointer;
}
</style>
